import React from 'react';
import { get } from 'lodash';
import GoogleMap from 'google-map-react';
import { EuiDescriptionList, EuiFlexItem, EuiFlexGroup } from 'stable-eui';
import { appConfig } from 'config';
import mapStyles from './mapStyles.json';
import BuuCucMarker from './BuuCucMarker';

const BuuCuc = (props) => {
  const tab1Data = get(props.data, 'tab1Data', {});
  const userData = get(props.data, 'userData', {});

  const leftTab1 = [
    {
      title: 'Tên bưu cục',
      description: get(tab1Data, 'TEN_BUUCUC', ''),
    },
    {
      title: 'Số điện thoại',
      description: get(tab1Data, 'PHONE', ''),
    },
    {
      title: 'Địa chỉ',
      description: get(tab1Data, 'ADDRESS', ''),
    },
    {
      title: 'Họ tên người phụ trách',
      description: `-`,
    },
    {
      title: 'SĐT',
      description: get(userData, 'TELEPHONE', ''),
    },
  ];

  return (
    <EuiFlexGroup className="buuCuc" style={{ paddingTop: 20 }}>
      <EuiFlexItem>
        <EuiDescriptionList textStyle="reverse" listItems={leftTab1} />
      </EuiFlexItem>
      {get(tab1Data, 'LATITUDE') && (
        <EuiFlexItem>
          <GoogleMap
            bootstrapURLKeys={{ key: appConfig.googleMapKey }}
            style={{
              width: '100%',
              height: '100%',
              right: 10,
              top: '0',
              left: '0',
            }}
            language={'vi-VN'}
            yesIWantToUseGoogleMapApiInternals={true}
            // onGoogleApiLoaded={(gmap) => console.log('gmap', gmap)}
            options={{
              styles: mapStyles,
              fullscreenControl: false,
            }}
            zoom={15}
            defaultCenter={{
              lat: Number(get(tab1Data, 'LATITUDE', 0)) || 0,
              lng: Number(get(tab1Data, 'LONGITUDE', 0)) || 0,
            }}
          >
            <BuuCucMarker
              lat={Number(get(tab1Data, 'LATITUDE', 0)) || 0}
              lng={Number(get(tab1Data, 'LONGITUDE', 0)) || 0}
              text={get(tab1Data, 'TEN_BUUCUC', '')}
            />
          </GoogleMap>
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  );
};

// export default GoogleApiWrapper({
//   apiKey:  appConfig.googleMapKey,
//   language: 'vi-VN'
//  })(BuuCuc);

export default BuuCuc;
